<!--
登录
-->
<template>
	<el-row class="page flex-col-center">
		<el-col :sm="14" :xs="0" class="cover-container">
			<img class="login-cover" src="@/assets/images/login_cover.png" />
		</el-col>
		<el-col :sm="10" :xs="{ span: 24, offset: 2 }">
			<div class="form-container" v-loading="loading">
				<div class="form-title">你好！</div>
				<div class="form-text">欢迎登录岗位助手系统</div>
				<div v-if="loginType === 0" v-loading="loading">
					<div id="login_container"></div>
				</div>
				<el-form v-else :model="form" :rules="rules" ref="loginRef" class="login-form">
					<el-form-item label="CODE" prop="clientCode">
						<el-input v-model="form.clientCode"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="username">
						<el-input v-model="form.username"></el-input>
					</el-form-item>
					<div>
						<el-form-item label="密码" prop="pwd">
							<el-input v-model="form.pwd" show-password></el-input>
						</el-form-item>
					</div>
					<el-form-item style="margin-top: 10px">
						<el-checkbox v-model="form.keep" style="color: #999">记住我的账号密码</el-checkbox>
					</el-form-item>
					<el-form-item>
						<div class="box-btn" style="width: 100%; height: 40px" @click="login">
							立即登录
						</div>
						<div style="text-align: center; color: #888888;font-size: 12px;">服务热线：028-62997265</div>
					</el-form-item>
				</el-form>
				<!-- <el-button @click="checkLoginType" style="width: 100%">{{ loginType === 0 ? '管理员' : '用户' }}登录</el-button> -->
			</div>
		</el-col>
		<div class="box-bg"></div>
	</el-row>
</template>

<script>
	import {
		encryptDes,
		decryptDes
	} from '@/utils'
	export default {
		components: {},
		data() {
			return {
				appid: 'wx52b077bda76e6e86',
				loginType: 1, // 0 用户 1 管理员
				form: {
					clientCode: '', // 客户方code 仅作为管理员登录使用
					username: '',
					pwd: '',
					keep: false
				},
				loading: false,
				rules: {
					clientCode: {
						required: true,
						message: '请输入code',
						trigger: 'blur'
					},
					username: {
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					},
					pwd: {
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}
				}
			}
		},
		computed: {
			businessCode() {
				return this.$store.state.user.businessCode
			}
		},
		watch: {},
		mounted() {
			// 获取本地存储的code
			const localBusinessCode = sessionStorage.getItem('businessCode')
			this.form.clientCode = localStorage.getItem('clientCode') || ''
			// 获取本地存储的账号信息
			const loginData = localStorage.getItem('loginData')
			// 存入vueX
			if (localBusinessCode) {
				this.$store.commit('user/setBusinessCode', localBusinessCode)
			}
			// 勾选记住密码
			if (localStorage.getItem('keepUser') === '1') this.form.keep = true
			// 回显账号
			if (loginData) {
				const data = JSON.parse(decryptDes(loginData))
				this.form.username = data.u
				this.form.pwd = data.p
			}

			// 微信扫码登录
			// this.getAppid()
			// this.getCodeImage()
		},
		methods: {
			// 切换登录
			checkLoginType() {
				if (this.loginType === 0) {
					this.loginType = 1
					this.rules.clientCode.required = true
				} else {
					this.loginType = 0
					this.rules.clientCode.required = false
					this.$nextTick(() => {
						this.getCodeImage()
					})
				}
			},

			// 获取appid
			async getAppid() {
				const {
					data
				} = await this.$api.user.getAppid()
				if (data.code === 200) {
					this.appid = data.data
				}
			},

			// 获取扫码登录二维码
			getCodeImage() {
				const redirectUri = 'http://a8r4v9.natappfree.cc'
				// eslint-disable-next-line no-undef
				const wxImage = new WxLogin({
					id: 'login_container',
					appid: this.appid,
					scope: 'snsapi_login',
					redirect_uri: redirectUri,
					state: this.businessCode,
					style: 'white',
					href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKICBkaXNwbGF5OiBub25lOwp9CgouaW1wb3dlckJveCAuc3RhdHVzLnN0YXR1c19icm93c2VyIHsKICBkaXNwbGF5OiBub25lOwp9CgouaW1wb3dlckJveCAuc3RhdHVzIHsKICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7Cn0='
				})
			},

			// 登录
			login() {
				this.$refs.loginRef.validate((valid) => {
					if (valid) {
						this.loading = true
						this.$api.user
							.login({
								account: this.form.username,
								password: this.form.pwd,
								businessUniqueCode: this.businessCode,
								clientUniqueCode: this.form.clientCode
							})
							.then(async ({
								data
							}) => {
								if (data.code === 200) {
									const TOKEN = data.data.token
									sessionStorage.setItem('token', TOKEN)
									sessionStorage.setItem('endDay', data.data.endDay || '')
									let serviceExtension = {
										endDay: data.data.endDay || '', //服务结束时间
										status: data.data.status || '', //是否已经申请延期
										applyExpirationTime: data.data.applyExpirationTime || '' //服务延期至日期
									}
									this.$store.commit('user/setServiceExtension', serviceExtension)

									try {
										await this.$store.dispatch('user/getInfo')
										await this.$store.dispatch('user/getMenu')
										// 存储code
										sessionStorage.setItem('businessCode', this.businessCode)
										localStorage.setItem('clientCode', this.form.clientCode)
										this.updateLocalAccount()
										this.$router.push({
											path: '/'
										})
									} catch (err) {
										this.$store.dispatch('user/resetAuth')
										this.loading = false
										this.$message.error(err)
									}
								} else {
									this.loading = false
								}
							})
							.catch(() => {
								this.loading = false
							})
					} else return false
				})
			},

			updateLocalAccount() {
				// 记住账号密码
				if (this.form.keep) {
					localStorage.setItem('keepUser', '1')
					const data = {
						u: this.form.username,
						p: this.form.pwd
					}
					localStorage.setItem('loginData', encryptDes(JSON.stringify(data)))
				} else {
					// 清空账号密码
					localStorage.removeItem('keepUser')
					localStorage.removeItem('loginData')
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		min-height: 100vh;
		padding-bottom: 150px;
		box-sizing: border-box;
		position: relative;
	}

	.cover-container {
		text-align: right;

		.login-cover {
			width: 7.38rem;
			height: 6rem;
			margin-right: 70px;
			object-fit: cover;
		}
	}

	.form-container {
		display: inline-block;
		padding: 40px 59px 46px 49px;
		background: #fff;
		box-shadow: 0px 0px 32px 0px rgba(194, 194, 194, 0.2);
		border-radius: 10px;

		.form-title {
			font-size: 30px;
			font-family: 'FZJinCaiTiS';
			font-weight: 800;
			color: #333333;
		}

		.form-text {
			margin: 20px 0 30px 0;
			font-size: 14px;
			font-family: 'Microsoft YaHei';
			color: #999999;
		}
	}

	/deep/ .login-form {
		width: 340px;

		.el-input__inner {
			background: #f6f7f9;
			border-radius: 4px;
			border: none;
		}

		.el-form-item__label {
			color: #999999;
		}
	}

	/deep/ .no-bottom .el-form-item {
		margin-bottom: 0;
	}

	.code-container {
		width: 360px;
		display: flex;
		flex-direction: column;
		align-items: center;

		img {
			width: 208px;
			height: 208px;
			margin-bottom: 60px;
			display: block;
		}
	}

	.box-bg {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 150px;
		background-image: url('../../assets/images/login_bg.png');
		background-size: cover;
	}
</style>
